<template>
  <v-container class="container-max-widths">
    <v-row class="d-sm-none">
      <v-col>
        <v-sheet elevation="1">
          <v-list-item>
            <v-list-item-icon @click="showMobileNav = !showMobileNav" class="d-sm-none">
              <v-icon>mdi-menu</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="title">
                Dashboard
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ currentView }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-expand-transition>
            <v-list dense nav v-show="showMobileNav">
              <v-list-item
                v-for="item in items"
                :key="item.title"
                link
                :to="item.to"
                :exact="item.exact"
                color="primary"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item link to="/dashboard/account">
                  <v-list-item-icon>
                    <v-icon>mdi-cog</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Account Settings</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link @click="logoutUser">
                  <v-list-item-icon>
                    <v-icon>mdi-lock</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-list>
          </v-expand-transition>
        </v-sheet>
      </v-col>
    </v-row>
    <v-sheet elevation="1" class="mt-6">
      <v-row no-gutters>
        <v-col class="py-0 pr-0 d-sm-block d-none" cols="auto">
          <v-navigation-drawer permanent>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title">
                  Dashboard
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ currentView }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense nav>
              <v-list-item
                v-for="item in items"
                :key="item.title"
                link
                :to="item.to"
                :exact="item.exact"
                color="primary"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <template v-slot:append>
              <v-list dense nav>
                <v-list-item link to="/dashboard/contact-us" color="primary">
                  <v-list-item-icon>
                    <v-icon>mdi-mail</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Contact Us</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item link to="/dashboard/account" color="primary">
                  <v-list-item-icon>
                    <v-icon>mdi-cog</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Account Settings</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item link @click="logoutUser" color="primary">
                  <v-list-item-icon>
                    <v-icon>mdi-lock</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-navigation-drawer>
        </v-col>
        <v-col>
          <div style="min-height: 510px">
            <router-view></router-view>
          </div>
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DashboardBase",
  data() {
    return {
      showMobileNav: false,
      items: [
        {
          title: "Home",
          icon: "mdi-view-dashboard",
          to: "/dashboard",
          exact: true,
        },
        {
          title: "Order History",
          icon: "mdi-text-box-multiple",
          to: "/dashboard/orders",
          exact: false,
        },
        {
          title: "New Order",
          icon: "mdi-text-box-plus",
          to: "/dashboard/new-order",
          exact: false,
        },
      ],
      right: null,
    };
  },
  computed: {
    currentView() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    logoutUser() {
      this.logout().then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style scoped>
  @media (min-width: 1904px) {
    .container {
        max-width: 1400px !important;
    }
  }
</style>
